module.exports = __webpack_public_path__ + "static/media/linkedin.cb7194d9.svg";